<div class="row mb-4 mt-3">
  <div class="col-md-12 d-flex flex-row align-items-center">
    <h4 class="mb-0">
      <div (click)="voltar()" style="cursor: pointer;padding: 2px 20px 0 0;float: left;">
        <i class="fas fa-arrow-left"></i>
      </div>
      Configurações da eleição <strong>{{eleicaoParametrizacao.titulo}}</strong>
    </h4>
    <div class="badger"> {{eleicaoParametrizacao.statusEleicao.replace('_', ' ')}}
    </div>
  </div>
</div>
<!-- -->
<div class="row">
  <div class="col-md-12">
    <nav>
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active" id="nav-contact-tab" data-toggle="tab" href="#nav-eleicao" role="tab"
          aria-controls="nav-eleicao">Informações</a>
        <a class="nav-item nav-link" *ngIf="temIntegracao == true" id="nav-integra-tab" data-toggle="tab"
          href="#nav-integra" role="tab" aria-controls="nav-contact">Integração</a>
        <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-cargos" role="tab"
          aria-controls="nav-contact">Cargos / Pautas</a>
        <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-candidatos" role="tab"
          aria-controls="nav-profile">Candidatos / Respostas</a>
        <a class="nav-item nav-link" *ngIf="temCandidaturas == true" id="nav-profile-tab" data-toggle="tab"
          href="#nav-candidaturasNav" role="tab" aria-controls="nav-profile">Campanha de Candidaturas</a>
        <a class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#nav-eleitores" role="tab"
          aria-controls="nav-home"> Eleitores</a>
        <a class="nav-item nav-link" id="nav-backlist-tab" data-toggle="tab" href="#nav-blacklist" role="tab"
          aria-controls="nav-contact">Blacklist</a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade show active pt-4" id="nav-eleicao" role="tabpanel">
        <app-cadastro-eleicao></app-cadastro-eleicao>
      </div>
      <div class="tab-pane fade" id="nav-eleitores" role="tabpanel">
        <app-eleitor></app-eleitor>
      </div>
      <div class="tab-pane fade" id="nav-integra" role="tabpanel">
        <app-integracao></app-integracao>
      </div>
      <div class="tab-pane fade" id="nav-blacklist" role="tabpanel">
        <cadastro-blacklist></cadastro-blacklist>
      </div>
      <div class="tab-pane fade" id="nav-candidatos" role="tabpanel">
        <cadastro-candidato></cadastro-candidato>
      </div>
      <div class="tab-pane fade" id="nav-candidaturasNav" role="tabpanel">
        <app-candidaturasNav></app-candidaturasNav>
      </div>
      <div class="tab-pane fade" id="nav-cargos" role="tabpanel">
        <cadastro-cargo></cadastro-cargo>
      </div>
    </div>
  </div>
</div>